import { environmentName } from '../config';

export function generateQuoteProposalPageURL(proposalId: string, vendorGUID: string) {
  return `https://app${
    environmentName === 'dev' ? '.dev' : ''
  }.trnsact.com/quoteproposal/?vendorGUID=${vendorGUID}&proposalId=${proposalId}&viewOnly=true`;
}
